module.exports = __webpack_public_path__ + "pencil.jpg?4afbfb361986b7a1bdc70519466f3b4d";